// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-cart-checkout__line-item',
    // #endregion
    // #region Events
    emits: ["command"],
    // #endregion
    // #region Properties
    props: {
        cart: {
            type: Object,
            required: false,
            default: {}
        },
        schema: {
            type: Object,
            required: false,
            default: {}
        },
        data: {
            type: Object,
            required: false,
            default: {}
        },
        item: {
            type: Object,
            required: true,
            default: {}
        },
        status: {
            type: Object,
            required: true,
            default: {}
        },
        isReadOnly: {
            type: Boolean,
            required: false,
            default: true
        },
    },
    // #endregion
    // #region Methos
    methods: {
        // #region CRUD (Line)
        async deleteLine(event, line) {
            // #region Event
            event.preventDefault();
            // #endregion
            // #region Run
            try {
                // #region Run
                let tResult = await host.api.delete(`commerce/checkout/${this.cart.cartID}/lines/${line.lineID}`);
                // #endregion
                // #region Command
                this.$emit('command', {
                    name: 'set',
                    cart: tResult.data?.cart,
                    schema: tResult.data?.schema
                });
                // #endregion
            }
            catch (e) {
                host.notification.showError(e);
            }
            // #endregion
        },
        async updateLine(event, line) {
            // #region Check
            if (this.status.isLoading) {
                return;
            }
            //Set
            {
                this.status.isLoading = true;
            }
            // #endregion
            // #region Run
            try {
                // #region Run
                let tResult = await host.api.patch(`commerce/checkout/${this.cart.cartID}/lines/${line.lineID}`, { quantity: line.quantity });
                // #endregion
                // #region Command
                await this.$emit('command', {
                    name: 'set',
                    cart: tResult.data?.cart,
                    schema: tResult.data?.schema
                });
                // #endregion                   
            }
            catch (e) {
                host.notification.showError(e);
            }
            finally {
                this.status.isLoading = false;
            }
            // #endregion
        },
        // #endregion
        // #region Commands
        async cmdRunLineCommand(name, line) {
            if (name === 'files') {
                this.uploadDocuments(line);
            }
            else if (name === 'comment') {
                this.lineComment(line);
            }
            else if (name === 'configuration-show') {
                host.actions.tryExecute('288a.commerce.configuration.showByCartLine', { cart: this.cart, line: this.item });
            }
            else if (name === 'configuration-edit') {
                host.actions.tryExecute('288a.commerce.configuration.editByCartLine', { cart: this.cart, line: this.item, _callback: this.onReload });
            }
        },
        lineComment(line) {
            //Run
            let tData = {
                cartName: this.cart.cartName,
                cartID: this.cart.cartID,
                lineID: line.lineID,
                line: line,
                comment: line.comment
            };
            host.notification.showModal(host.components.getComponent('g-cart-line-comment'), tData, { size: 'default' });
        },
        uploadDocuments(line) {
            //Run
            let tData = {
                cartName: this.cart.cartName,
                cartID: this.cart.cartID,
                lineID: line.lineID,
                line: line
            };
            host.notification.showModal(host.components.getComponent('g-cart-files-upload'), tData, { size: 'default' });
        },
        onReload() {
            this.$emit('command', { name: 'reload', });
        }
        // #endregion
    }
    // #endregion       
});
// #endregion
